'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var dialog = require('@reach/dialog');
require('@reach/dialog/styles.css');
var framerMotion = require('framer-motion');
var ModalContent = require('./ModalContent.js');
var classNames = require('classnames/bind');
var Modal_module = require('./Modal.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var cx = classNames__default["default"].bind(Modal_module["default"]);
var MotionDialogOverlay = framerMotion.motion(dialog.DialogOverlay);
var motionOverlayVariants = {
    initial: { opacity: 0, transition: { duration: 0.5 } },
    animate: { opacity: 1, transition: { duration: 0.5 } },
    exit: { opacity: 0, transition: { duration: 0.75 } },
};
var motionContentVariants = {
    initial: {
        opacity: 0,
        y: -50,
        transition: { duration: 0.5 },
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: { type: 'tween', stiffness: 75, duration: 0.5 },
    },
    exit: {
        opacity: 0,
        y: -50,
        transition: { duration: 0.25 },
    },
};
var Modal = function (_a) {
    var _b = _a.isVisible, isVisible = _b === void 0 ? false : _b, onCancel = _a.onCancel, ariaLabel = _a.ariaLabel, children = _a.children, _c = _a.width, width = _c === void 0 ? 'default' : _c, dialogContentClassName = _a.dialogContentClassName, rest = _tslib.__rest(_a, ["isVisible", "onCancel", "ariaLabel", "children", "width", "dialogContentClassName"]);
    var isPredefinedWidth = ['default', 'small', 'medium', 'large'].includes(width);
    var inlineStyle = !isPredefinedWidth ? { width: width } : {};
    var dialogContentClass = cx(Modal_module["default"].dialogContent, dialogContentClassName, isPredefinedWidth && "width-".concat(width));
    return (jsxRuntime.jsx(framerMotion.AnimatePresence, { children: isVisible && (jsxRuntime.jsx(MotionDialogOverlay, _tslib.__assign({ className: Modal_module["default"].dialogOverlay, isOpen: isVisible, onDismiss: onCancel, variants: motionOverlayVariants, initial: "initial", animate: "animate", exit: "exit" }, { children: jsxRuntime.jsx(framerMotion.motion.div, _tslib.__assign({ variants: motionContentVariants, initial: "initial", animate: "animate", exit: "exit" }, { children: jsxRuntime.jsx(dialog.DialogContent, _tslib.__assign({ style: inlineStyle, className: dialogContentClass, "aria-label": ariaLabel }, { children: jsxRuntime.jsx(ModalContent["default"], _tslib.__assign({}, rest, { onCancel: onCancel }, { children: children })) })) })) }))) }));
};

exports["default"] = Modal;
//# sourceMappingURL=Modal.js.map
